<template>
  <div class="bradgall pr-8">
    <div class="flex gap-6">
      <div class="w-5/12"><CampaignStatus /></div>

      <div class="w-4/12">
        <!-- <ExploreWeb3 /> -->
        <RecommendedUpgrade />
      </div>
      <div class="w-3/12"><MyResources /></div>
    </div>
  </div>
</template>
<script>
import CampaignStatus from "@/views/adminPanel/pages/marcom/components/CampaignStatus.vue";
import RecommendedUpgrade from "@/views/adminPanel/pages/dashboard/components/RecommendedUpgrade.vue";
import ExploreWeb3 from "@/views/adminPanel/pages/dashboard/components/ExploreWeb3.vue";
import MyResources from "@/views/adminPanel/pages/dashboard/components/MyResources.vue";
export default {
  data() {
    return {};
  },

  methods: {},
  components: {
    ExploreWeb3,
    RecommendedUpgrade,
    MyResources,
    CampaignStatus,
  },
};
</script>
